import {
    MainMeansOfTransport,
} from 'app/enums/label.enums'

const TransportMode = ({
    value,
}: {
    value: MainMeansOfTransport
}) => {
    if (!value) {
        return null
    }

    return (
        <img
            src={`assets/images/orderSteps/${value?.toLowerCase()}.svg`}
            alt={value}
        />
    )
}

export default TransportMode
